module.exports = __webpack_public_path__ + "static/media/galaxtraz-high-orbit-prison.e2e8c252.jpg";